import { cn } from '@tebuto/lib/utils'
import type { JSX } from 'react'

interface SuffixProps {
    suffix?: string
    className?: string
}

export default function Suffix({ suffix, className = '' }: SuffixProps): JSX.Element {
    if (suffix) {
        return (
            <span
                className={cn(
                    'inline-flex h-full shrink-0 items-center text-xs px-3 rounded-r-md border border-l-0 border-secondary bg-surface-muted text-foreground-secondary sm:text-sm',
                    className
                )}
            >
                {suffix}
            </span>
        )
    }
    return <></>
}
